var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-text-field',{staticClass:"rounded-0",attrs:{"append-icon":"fas fa-search","label":"Buscar","hide-details":"","height":"45px","dense":"","solo":"","flat":""}})}
var staticRenderFns = []

export { render, staticRenderFns }